import type { ResolvedSite } from '~~/types/tenant'

export default defineNuxtPlugin(() => {
  const tenant = useState<ResolvedSite | null>('tenant-site', () => null)
  const isPlatform = useState<boolean>('is-platform', () => true)

  if (import.meta.server) {
    const event = useRequestEvent()
    tenant.value = event?.context.tenant ?? null
    isPlatform.value = !tenant.value
  }
})
